<template>
  <div class="legal-document-content">
    <slot />
  </div>
</template>

<style scoped>
.legal-document-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 24px 32px 48px;
  border-radius: 8px;
  word-break: break-word;
}

.legal-document-content :deep(.legal-intro) {
  margin: 0;
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-title-large);
  line-height: var(--line-height-title-large);
  color: var(--black-body-text);
}

.legal-document-content :deep(.legal-section) {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 16px 0;
}

.legal-document-content :deep(.legal-section__title) {
  margin: 0;
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-headline-small);
  line-height: var(--line-height-headline-small);
  color: var(--primary-blue);
}

.legal-document-content :deep(.legal-section__body),
.legal-document-content :deep(.legal-section__body p) {
  margin: 0;
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-body-large);
  line-height: var(--line-height-body-large);
  letter-spacing: 0.08px;
  color: var(--black-body-text);
}

.legal-document-content :deep(.legal-section__body p + p),
.legal-document-content :deep(.legal-section__body p + ul),
.legal-document-content :deep(.legal-section__body ul + p) {
  margin-top: 0;
}

.legal-document-content :deep(.legal-section__body ul) {
  margin: 0;
  padding-left: 24px;
  list-style: disc;
}

.legal-document-content :deep(.legal-section__body li) {
  margin: 0;
  padding-left: 0;
}

.legal-document-content :deep(.legal-section__body li::marker) {
  color: var(--black-body-text);
}

@media (max-width: 768px) {
  .legal-document-content {
    gap: 0;
    padding: 0 0 24px;
    border-radius: 0;
  }

  .legal-document-content :deep(.legal-intro) {
    padding: 16px;
    font-size: var(--font-size-title-big);
    line-height: var(--line-height-title-big);
    letter-spacing: 0.03px;
  }

  .legal-document-content :deep(.legal-section) {
    padding: 32px 16px;
  }

  .legal-document-content :deep(.legal-section__title) {
    font-size: var(--font-size-headline-small);
    line-height: var(--line-height-headline-small);
  }
}
</style>
